import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "forecast-for-receipt-menu-dropdown-container",
  class: "forecast-for-receipt-menu"
}
const _hoisted_2 = {
  id: "forecast-for-receipt-menu-dropdown-content",
  class: "forecast-for-receipt-menu__dropdown"
}
const _hoisted_3 = ["onClick"]

import { i18n } from '@/i18n';
import { FORECAST_FOR_RECEIPT_DROPDOWN_MENU_ITEMS } from '../constants';
import { ForecastForReceiptMenuService } from '../domains/services/forecastForReceiptMenuService';
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import { watch } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { ForecastForReceiptMenuItems } from '../domains/entities/ForecastForReceiptMenu';

const OPTION_HEIGHT = 40;


export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastForReceiptMenuDropdown',
  props: {
    isSelectedBusinesses: { type: Boolean },
    isOpenProp: { type: Boolean },
    selectedItemProp: {}
  },
  emits: ["click:selectInput", "selectedItem", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const t = i18n.t;

const selectedItem = ref<ForecastForReceiptMenuItems>();
const isOpen = ref(false);

const emit = __emit;

watch(
  () => props.isOpenProp,
  () => {
    isOpen.value = props.isOpenProp || false;
  }
);

watch(
  () => props.selectedItemProp,
  () => {
    selectedItem.value = props.selectedItemProp;
  }
);

watch(isOpen, async (newVal) => {
  if (newVal) {
    emit('click:selectInput');
    calculateDropdownPosition();
  }
});

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

/**
 * 受領用内示メニューの項目を非活性にするかどうか
 * @param item - 受領用内示メニューの項目
 */
const isDisabledItem = (item: ForecastForReceiptMenuItems): boolean => {
  return ForecastForReceiptMenuService.isBaseBusinessRelatedItem(item) && !props.isSelectedBusinesses;
};

/**
 * オプションを選択し、親コンポーネントに選択値を通知します。
 * @param item - 選択したアイテム
 */
const selectOption = (item: ForecastForReceiptMenuItems) => {
  selectedItem.value = item;
  emit('selectedItem', item);
  isOpen.value = false;
  emit('close');
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!isOpen.value) return;
  const target = event.target;
  const selector = '#forecast-for-receipt-menu-dropdown-container';
  const arrowSelector = '#forecast-for-receipt-menu-dropdown-arrow';
  const searchSelector = '#forecast-for-receipt-menu-dropdown-content';
  if (!(target instanceof Element)) return;
  if (target.closest(arrowSelector)) return;
  if (target.closest(selector)) return;
  if (target.closest(searchSelector)) return;

  isOpen.value = false;
  emit('close');
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.addEventListener('click', closeDropdown);
});

/**
 * ドロップダウンの位置を計算し、設定します。
 */
const calculateDropdownPosition = () => {
  nextTick(() => {
    const selectBox = document.querySelector('#forecast-for-receipt-menu-dropdown-container') as HTMLElement;
    if (selectBox) {
      const rect = selectBox.getBoundingClientRect();
      const dropdown = document.querySelector('#forecast-for-receipt-menu-dropdown-content') as HTMLElement;
      if (dropdown) {
        dropdown.style.left = `${rect.left}px`;
        dropdown.style.top = `${rect.bottom}px`;

        // ドロップダウンの高さを計算
        const desiredHeight = OPTION_HEIGHT * FORECAST_FOR_RECEIPT_DROPDOWN_MENU_ITEMS.length;

        // max-heightを計算して設定
        const availableHeight = window.innerHeight - rect.bottom - 10; // 10pxは少しのマージン
        dropdown.style.maxHeight = `${Math.min(desiredHeight, availableHeight)}px`;
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "forecast-for-receipt-menu_container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDropdown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "forecast-for-receipt-menu__selected",
        onClick: toggleDropdown
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`forecast-for-receipt-menu__field ${selectedItem.value === undefined ? 'forecast-for-receipt-menu__field--placeholder' : ''}`)
        }, _toDisplayString(selectedItem.value === undefined ? _unref(t)('受領用内示') : _unref(ForecastForReceiptMenuService).getDisplayText(selectedItem.value)), 3),
        (isOpen.value)
          ? (_openBlock(), _createBlock(SvgLoader, {
              key: 0,
              name: "arrowUpBlue",
              class: "forecast-for-receipt-menu__arrow"
            }))
          : (_openBlock(), _createBlock(SvgLoader, {
              key: 1,
              id: "forecast-for-receipt-menu-dropdown-arrow",
              name: "arrowDownBlue",
              class: "forecast-for-receipt-menu__arrow"
            }))
      ]),
      (isOpen.value)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: "body"
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FORECAST_FOR_RECEIPT_DROPDOWN_MENU_ITEMS), (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option,
                  class: _normalizeClass(["forecast-for-receipt-menu__option", { 'forecast-for-receipt-menu__option--disabled': isDisabledItem(option) }]),
                  onClick: ($event: any) => (!isDisabledItem(option) && selectOption(option))
                }, _toDisplayString(_unref(ForecastForReceiptMenuService).getDisplayText(option)), 11, _hoisted_3))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})